<template>
	<div class="graphic-component">
		<div>
			<v-layout wrap justify-space-between align-center mb-2>
				<v-flex xs10>
					<span class="title-graphic"
						:style="`color:${$appColors.info}`"
					>{{ title }}</span>
				</v-flex>
				<v-flex xs2 text-xs-right>
					<v-icon
						:disabled="disabled"
						color="success"
						size="20"
					>
						check_circle
					</v-icon>
				</v-flex>
			</v-layout>
			<v-flex>
				<progress-bar
					:quantity="5"
					:value="value"
				></progress-bar>
			</v-flex>
			<v-flex xs12 text-xs-right>
				<span :style="`opacity: ${!disabled ? 1 : 0}`" class="success--text complete-text">Completo</span>
			</v-flex>
			<v-layout d-flex justify-center mt-4 mb-3>
				<div class="canvas-container">
					<canvas :id="`canvas-${areaId}`" width="176" height="87"></canvas>
				</div>
			</v-layout>
		</div>
	</div>
</template>

<script>
import progressBar from '@/components/shared/progress-bar';

/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-parens */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-undef */
function mounted() {
	this.startGraphic();
}

function startGraphic() {
	const leftName = this.kindEntity.length > 0 ? this.kindEntity[0].name : '';
	const rightName = this.kindEntity.length > 0 ? this.kindEntity[1].name : '';
	let inverse = false;
	if (this.kindEntity.length > 0) {
		inverse = this.kindEntity[0].id !== this.kindEntityId;
	}
	const data = {
		radius: 65,
		numberElements: 5,
		leftName,
		rightName,
		inverse,
		offsetGraphhX: 20,
		duration: 0.5,
		toProgressLeft: 0 / 5,
		toProgressRight: 0 / 5,
		prevData: {
			left: 0 / 5,
			right: 0 / 5,
		},
		endAnimation: () => console.log('endAnimation'),
		onStop: () => console.log('onStop'),
		ease: (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
	};

	// 5. Comenzar animacion
	const graph = new GraphAnimator(data);
	const canvas = document.getElementById(`canvas-${this.areaId}`);
	const valueLeftToUse = this.areaId === this.areas[1].id ? this.graphicValueLeftSecond :
		this.graphicValueLeft;
	const valueRightToUse = this.areaId === this.areas[1].id ? this.graphicValueRightSecond :
		this.graphicValueRight;
	graph.updateLeft(valueLeftToUse / 5);
	graph.updateRight(valueRightToUse / 5);
	startAnimation(canvas, graph.getData());
}

function graphicValueLeft(val) {
	if (val >= 0) {
		this.startGraphic();
	}
}

function graphicValueLeftSecond(val) {
	if (val >= 0) {
		this.startGraphic();
	}
}

function graphicValueRight(val) {
	if (val >= 0) {
		this.startGraphic();
	}
}

function graphicValueRightSecond(val) {
	if (val >= 0) {
		this.startGraphic();
	}
}

export default {
	name: 'graphic-component',
	components: {
		progressBar,
	},
	methods: {
		startGraphic,
	},
	mounted,
	props: {
		areaId: Number,
		areas: {
			default: () => [],
			type: Array,
		},
		disabled: {
			type: Boolean,
			default: true,
		},
		graphicValueLeft: Number,
		graphicValueLeftSecond: Number,
		graphicValueRight: Number,
		graphicValueRightSecond: Number,
		kindEntity: {
			default: () => [],
			type: Array,
		},
		kindEntityId: Number,
		title: String,
		value: {
			type: Number,
			default: 0,
		},
	},
	watch: {
		graphicValueLeft,
		graphicValueLeftSecond,
		graphicValueRight,
		graphicValueRightSecond,
	},
};
</script>

<style lang="scss" scoped>
.title-graphic {
	font-size: map-get($sizes, small);
	font-family: map-get($fonts, bold);
}

.graphic-component {
	padding: 0px 49px;
}

.v-progress-linear {
	border-radius: 5.5px;
}

.complete-text {
	font-size: 9px;
}

.canvas-container {
	max-width: 176px;
}
</style>




// WEBPACK FOOTER //
// src/components/surveys/graphic-component.vue